<template>
  <div class="Setpermissions CommonContentSingle-white">
    <div class="Thelist" v-loading="loading">

      <div style="margin-bottom:10px;">
        <el-button type="primary" @click="saves">保存</el-button>
        <!-- <el-button type="primary" @click="xa">放松</el-button>
        <el-button type="primary" @click="xa2">月报</el-button> -->
      </div>

      <div class="Thelist_left">
        <p class="Thelist_ulli1">系统角色</p>
        <el-tree :data="data" show-checkbox node-key="id" check-strictly @check-change="handleClick" ref="treeForm">
        </el-tree>
      </div>

      <div class="Thelist_right">
        <p class="Thelist_ulli2">系统功能</p>
        <el-tree :data="data2" show-checkbox node-key="id" @check-change="handleClick2" ref="treeFosrm"></el-tree>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      activeName: 'second',
      formInline: {
        user: '',
        region: '',
      },
      i: 0,
      data: [],
      data2: [],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      array1: '',
      array2: '',
      array3: [
        '1420200514001',
        '111',
        '222',
        'CSJL',
        '1420200305001',
        '1420200318001',
        '14201910019',
        'QX',
      ],
    }
  },
  components: {},
  methods: {
    xa(){
      this.$router.push({ path: '/biofeedback/Relaxation_pod' });
    },
    xa2(){
      this.$router.push({ path: '/Data/Monthly' });
    },
    handleClick(data, checked, node) {
      this.$refs.treeFosrm.setCheckedKeys(this.array3);
      this.i++;
      if (this.i % 2 === 0) {
        if (checked) {
          this.$refs.treeForm.setCheckedNodes([]);
          this.$refs.treeForm.setCheckedNodes([data]);
          //交叉点击节点
        } else {
          this.$refs.treeForm.setCheckedNodes([]);
          //点击已经选中的节点，置空
        }
      }
      let res = this.$refs.treeForm.getCheckedKeys()
      this.array1 = res
      if (this.array1.length > 0) {
        this.$Http_Post('UserRoleDeptFunction/GetRoleMenu', {
          role: this.array1[0],
        }).then((res) => {
          let sc = [];
          if (res.Code == 200 || res.Code == 0) {
            if (res.Data.length >= 1) {
              for (var i = 0; i < res.Data.length; i++) {
                sc.push(res.Data[i].id);
              }
              this.array3 = sc;
              console.log(this.array3)
              this.$refs.treeFosrm.setCheckedKeys(this.array3);
            } else {
              this.array3 = ['a'];
              this.$refs.treeFosrm.setCheckedKeys(this.array3);
            }
          } else {
            this.Global.request_failure(res.Message)
          }
        })
      }
    },
    handleClick2(data, checked, node) {
      let res = this.$refs.treeFosrm.getCheckedKeys();
      let ress = this.$refs.treeFosrm.getHalfCheckedKeys();
      let arrDeptId = res.concat(ress);
      this.array2 = arrDeptId;
    },
    saves() {
      if ((this.array1 && this.array1.length > 0) && (this.array2 && this.array2.length > 0)) {
        this.$Http_Post('UserRoleDeptFunction/UpdateRoleFunction', {
          role: this.array1,
          menuids: this.array2,
        })
        .then((res) => {
          this.loading = false
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message)
          } else {
            this.Global.request_failure(res.Message)
          }
        })
      } else {
        this.Global.request_failure("请选择角色或系统功能")
      }
    },
    savess2() {
      this.$router.push('/Set/Set_clean')
    },
    savess3() {
      this.$router.push('/consulting/ConsultingFiles')
    },
    resetForm() {
      this.formInline.user = '';
      this.formInline.region = '';
    },
  },
  mounted() {
    this.$Http_Post('UserRoleDeptFunction/GetRoleFunction')
      .then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.data = res.Data[0].children;
          this.data2 = res.Data[1].children;
        } else {
        }
      })
  },
}
</script>
<style scoped>
.Setpermissions .Thelist {
  height: 100%;
}

.Setpermissions .Setdepartment_top {
  padding-top: 20px;
  font-size: 20px;
  border: 1px solid #e3e3e3;
  padding-bottom: 20px;
  margin-top: -1px;
  background-color: #fff;
}

.Setpermissions .Setdepartment_top form {
  margin-left: 20px;
}

.Setpermissions button {
  height: 38px;
}

.Setpermissions .el-form-item {
  margin-bottom: 0px;
}

.Setpermissions .Thelist_left {
  width: 20%;
  float: left;
  border: #d9d9d9 1px solid;
  min-height: calc(100% - 40px);
}

.Setpermissions .Thelist_right {
  width: calc(80% - 15px);
  float: right;
  border: #d9d9d9 1px solid;
  height: calc(100% - 40px);
  overflow-y: auto;
  overflow-x: hidden;
}

.Setpermissions .Thelist_ul {
  width: 100%;
  height: 60px;
  line-height: 60px;
}

.Setpermissions .Thelist_ulli1 {
  width: 100%;
  float: left;
  font-size: 16px;
  height: 30px;
  margin-left: 15px;
  margin-top: 10px;
}

.Setpermissions .Thelist_ulli2 {
  width: 100%;
  float: left;
  font-size: 16px;
  height: 30px;
  margin-left: 15px;
  margin-top: 10px;
}

.Setpermissions .Thelist[data-v-0a56ea16] {
  padding: 16px;
  background-color: #fff;
  min-height: 670px;
  border: 1px solid #e3e3e3;
  margin-top: 18px;
}

.Setpermissions .el-tree {
  padding-left: 20px;
  margin-top: 45px;
}
</style>
